import { call, put, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';
import Metrics from 'services/metrics';
import { set } from 'utils/LocalStorageUtil';
import { LOAD_USER_PINCODE } from '../constants';
import {
  pendingUserPinCode,
  errorUserPinCode,
  actionUserIsLoggedIn,
} from '../actions';
import { getUserLogInSSO } from '../service';
import {
  setProfileLastTouch,
  setProfileLastTouchFavorited,
} from '../../../utils/Socialization';

export function* doSendPinCode({ payload }) {
  yield put(pendingUserPinCode());
  try {
    const params = {
      numberfield: payload.phone,
      otp: payload.pin,
    };

    const request = yield call(getUserLogInSSO, params);

    const { status, errors, response } = request;
    if (response?.lasttouch) {
      if (response.lasttouch.profile)
        setProfileLastTouch(response.lasttouch.profile);
      if (response.lasttouch.favorited)
        setProfileLastTouchFavorited(response.lasttouch.favorited);
    }
    if (Number(status) === 200 && _.isEmpty(errors)) {
      set('sso', true);
      const metricsParams = {
        event: 'login',
        method: 'telcel prepago',
        user_id: response.user_id,
      };
      Metrics.newEvent(metricsParams);
      yield put(actionUserIsLoggedIn({ login: payload.login, response }));
    } else {
      const error = _.get(errors, '0');
      yield put(errorUserPinCode(error));
    }
  } catch (error) {
    yield put(errorUserPinCode(error));
  }
}

export default function* sendPinCodeSaga() {
  yield takeLatest(LOAD_USER_PINCODE.ACTION, doSendPinCode);
}
